var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconLogin = function IconLogin(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.906 25.587C7.263 28.473 11.008 30 16 30c4.942 0 8.66-1.5 11.021-4.33-2.032-.759-5.975-1.433-11.169-1.433-4.448 0-8.584.521-10.946 1.35zM30 16c0-9.028-4.972-14-14-14C6.972 2 2 6.972 2 16c0 3.136.613 5.771 1.775 7.89 2.546-1.022 7.07-1.653 12.077-1.653 5.218 0 9.824.661 12.324 1.743C29.37 21.847 30 19.181 30 16zM0 16C0 5.832 5.832 0 16 0s16 5.832 16 16-5.832 16-16 16S0 26.168 0 16zm20.563-3.068A4.568 4.568 0 0016 8.37a4.568 4.568 0 00-4.563 4.563A4.568 4.568 0 0016 17.495a4.568 4.568 0 004.563-4.563zm2 0A6.57 6.57 0 0116 19.495a6.57 6.57 0 01-6.563-6.563A6.57 6.57 0 0116 6.37a6.57 6.57 0 016.563 6.563z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "iconLogin_svg__a",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.906 25.587C7.263 28.473 11.008 30 16 30c4.942 0 8.66-1.5 11.021-4.33-2.032-.759-5.975-1.433-11.169-1.433-4.448 0-8.584.521-10.946 1.35zM30 16c0-9.028-4.972-14-14-14C6.972 2 2 6.972 2 16c0 3.136.613 5.771 1.775 7.89 2.546-1.022 7.07-1.653 12.077-1.653 5.218 0 9.824.661 12.324 1.743C29.37 21.847 30 19.181 30 16zM0 16C0 5.832 5.832 0 16 0s16 5.832 16 16-5.832 16-16 16S0 26.168 0 16zm20.563-3.068A4.568 4.568 0 0016 8.37a4.568 4.568 0 00-4.563 4.563A4.568 4.568 0 0016 17.495a4.568 4.568 0 004.563-4.563zm2 0A6.57 6.57 0 0116 19.495a6.57 6.57 0 01-6.563-6.563A6.57 6.57 0 0116 6.37a6.57 6.57 0 016.563 6.563z",
    fill: "#fff"
  })));
};

IconLogin.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconLogin;
//# sourceMappingURL=IconLogin.js.map